import { Routes } from '@angular/router';
import { permissionGuard } from '@core/auth/permission.guard';
import { APP_PERMISSIONS } from '@core/constants/permission.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const usersRoutes: Routes = [
  {
    title: 'pagesTitles.users',
    path: APP_ROUTES.USERS,
    canActivate: [permissionGuard(APP_PERMISSIONS.UsersRead)],
    loadComponent: () =>
      import('./pages/users-list').then((m) => m.UsersList),
  },
  {
    title: 'pagesTitles.userCreate',
    path: APP_ROUTES.USERS_NEW,
    canActivate: [permissionGuard(APP_PERMISSIONS.UsersRead)],
    loadComponent: () =>
      import('./components/user-form').then((m) => m.UserForm),
  },
  {
    title: 'pagesTitles.userRoles',
    path: APP_ROUTES.USERS_ROLES,
    canActivate: [permissionGuard(APP_PERMISSIONS.UsersRead)],
    loadComponent: () =>
      import('./pages/manage-user-roles').then((m) => m.ManageUserRoles),
  },
];
